import {QueryCache, QueryClient} from '@tanstack/react-query';
import {getDefaultStore} from 'jotai';

import {HttpError} from '@services/utils';
import {logoutAtom} from '@atoms/auth';

const store = getDefaultStore();

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      staleTime: 30_000,
      refetchOnWindowFocus: false,
    },
  },
  queryCache: new QueryCache({
    onError: (err) => {
      if (err instanceof HttpError && err.status === 401) {
        store.set(logoutAtom);
      }
    },
  }),
});
